import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { Observable, ReplaySubject } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import * as fromLookups from '../../../lookups';
import { IStatusMessage } from '../../../shared';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { IShowErrors } from '../../../shared/errors-sidenav';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import * as fromStore from '../store';
import { AccountAllocation } from '../store';
import * as reducer from '../store/account-allocation.reducer';
import * as selectors from '../store/account-allocation.selectors';

@Component({
    selector: 'ef-cost-allocation-container',
    templateUrl: './cost-allocation-container.component.html',
    styleUrls: ['./cost-allocation-container.component.scss'],
    standalone: false
})
export class CostAllocationContainerComponent implements OnInit, OnDestroy {
    accountAllocations$: Observable<AccountAllocation[]>;
    expenseType$: Observable<SelectItem[]>;
    costCenters$: Observable<SelectItem[]>;
    @Input() selectedError: IStatusMessage;
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    @Output() HasFacilityExpense = new ReplaySubject<boolean>(1);
    private active = true;
    constructor(
        private store: Store<reducer.State>,
        private log: LoggingService
    ) {}

    ngOnInit() {
        this.store.dispatch(fromStore.getAccountAllocations());
        this.store.dispatch(fromStore.getExpenseTypes());
        this.store.dispatch(new fromLookups.LoadUserGroups());
        this.setupObservables();
    }
    ngOnDestroy() {
        this.active = false;
    }
    setupObservables() {
        this.accountAllocations$ = this.store.pipe(
            select(selectors.selectAll),
            map(x => clone(x))
        );
        this.accountAllocations$
            .pipe(takeWhile(() => this.active))
            .subscribe(allocations => {
                this.log.verbose({
                    type: 'CostAllocationContainerComponent:accountAllocations$:FCE',
                    allocations,
                    FCE: allocations.find(x => x.Calctype === 'FCE')
                });
                this.HasFacilityExpense.next(
                    !!allocations.find(x => x.Calctype === 'FCE')
                );
            });
        // .pipe(
        //     map(x => x.find(y => y.Calctype === 'FCE')),
        //     map(x => !!x),
        //     map(x => this.HasFacilityExpense.next(x))
        // );
        this.expenseType$ = this.store.pipe(
            select(selectors.selectExpenseTypes),
            map(c =>
                c.map(x => ({
                    value: x.CalcType,
                    label: x.CalcDesc
                }))
            )
        );
        this.costCenters$ = this.store.pipe(
            select(fromLookups.getCostCenters),
            map(c =>
                c
                    .map(x => ({
                        value: x.GroupID,
                        label: x.GroupName
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );
    }

    onSaveCostAllocation($event: AccountAllocation[]) {
        this.log.verbose({
            type: 'CostAllocationContainerComponent:onSaveCostAllocation$',
            $event
        });
        this.store.dispatch(
            fromStore.putAccountAllocations({ accountAllocations: $event })
        );
    }
}
